import { toast } from 'react-toastify';
import { isStaleAuthClearInProgress } from './clearStaleAuthSession';

export const toastHandler = (data: any) => {
  if (isStaleAuthClearInProgress()) {
    return;
  }

  // Handle success messages
  if (data?.type === 'success') {
    return toast.success(data.message || 'Operation completed successfully');
  }
  
  // Handle error messages (existing logic)
  if (data?.errors && typeof data.errors === 'object') {
    const keys = Object.keys(data.errors);
    if (keys?.length > 0) {
      if (data?.errors[keys[0]]?.message) {
        return toast.error(data?.errors[keys[0]]?.message);
      } else {
        return toast.error(data?.errors[keys[0]]);
      }
    }
  }
  return toast.error(data?.message);
};
